export default {"src":"/_next/static/media/free-shipping.573543fb.svg","height":640,"width":640};